<template>
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_567_15968)">
			<path
				d="M10.0106 7.23167C10.4509 7.23167 10.8078 6.87475 10.8078 6.43447C10.8078 5.99419 10.4509 5.63727 10.0106 5.63727C9.5703 5.63727 9.21338 5.99419 9.21338 6.43447C9.21338 6.87475 9.5703 7.23167 10.0106 7.23167Z"
				fill="#1E53BC"
				stroke="#1E53BC"
				stroke-width="1.5"
				stroke-miterlimit="10"
			/>
			<path
				d="M9.99997 18.5357C14.7141 18.5357 18.5357 14.7141 18.5357 9.99997C18.5357 5.28581 14.7141 1.46423 9.99997 1.46423C5.28581 1.46423 1.46423 5.28581 1.46423 9.99997C1.46423 14.7141 5.28581 18.5357 9.99997 18.5357Z"
				stroke="#1E53BC"
				stroke-width="1.5"
				stroke-miterlimit="10"
			/>
			<path
				d="M9.99072 14.4582V9.62195"
				stroke="#1E53BC"
				stroke-width="1.5"
				stroke-miterlimit="10"
				stroke-linecap="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_567_15968">
				<rect width="20" height="20" fill="white" />
			</clipPath>
		</defs>
	</svg>
</template>

<script>
export default {
	name: "InfoIcon",
};
</script>
